import React from "react";

import "../button.css";
import "../icomoon.css";
import "./ExpandList.css";

interface IExpandListItemProps {
    value?: string;
    onDelete?: (index: number) => void;

    index?: number;

    readOnly?: boolean;

    extraButtons?: React.ReactNode[] | React.ReactNode;
}

class ExpandListItem extends React.Component<IExpandListItemProps> {
    constructor(props: Readonly<IExpandListItemProps>) {
        super(props);

        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    public render() {
        return (
            <li>
                <span className="expand-list-item-content">{this.props.children}</span>
                {
                    this.props.extraButtons
                        ? this.props.extraButtons
                        : null
                }
                {
                    this.props.readOnly
                        ? ""
                        : <button type="button" className="button btn-light" title="Remove Item" onClick={this.handleDeleteClick}><i className="icon-times" /></button>
                }
            </li>
        );
    }

    private handleDeleteClick() {
        if (this.props.onDelete && this.props.index !== undefined) {
            this.props.onDelete(this.props.index);
        }
    }
}

export default ExpandListItem;
